import React from 'react'
import Session from '../../Main/Services/User/session'
import { decodeJwtPayload } from '@/auth/utils/decode-jwt-payload'
import { KEY_LOCAL_STORAGE_TOKEN } from '../Auth.constants'
import { GetWrapperStytch, useStytchAdapter } from './stytch/StytchAdapter'

export interface WrapperProps {
  children: React.ReactNode
}

export enum AuthProviders {
  STYTCH = 'STYTCH'
}

export interface logoutProps {
  federated?: boolean
}

export interface IAuthAdapter {
  init: () => Promise<void>
  isAuthenticated: () => Promise<boolean>
  generateToken: () => Promise<string>
  logout: (props?: logoutProps) => Promise<void>
  getRenderLogin: () => JSX.Element
  redirectLogin: () => Promise<void>
}

interface JwtPayload {
  iss?: string
}

const authProviderMapper: Record<AuthProviders, () => IAuthAdapter> = {
  STYTCH: () => useStytchAdapter()
}

type WrapperComponent = React.FC<{ children: React.ReactNode }>

const wrapperAuthMapper: Record<AuthProviders, WrapperComponent> = {
  STYTCH: ({ children }) => GetWrapperStytch({ children })
}

export const getAuthAdapter = (provider: AuthProviders): IAuthAdapter => {
  const providerAdapter = authProviderMapper[provider]

  if (!providerAdapter) {
    throw new Error(`Authentication provider not implemented: ${provider}`)
  }

  return providerAdapter()
}

const getProviderFromToken = (): AuthProviders | undefined => {
  const token = Session.get(KEY_LOCAL_STORAGE_TOKEN)
  if (!token) return undefined
  const payload = decodeJwtPayload<JwtPayload>(token)
  const iss = payload?.iss
  if (iss?.includes(AuthProviders.STYTCH.toLowerCase())) return AuthProviders.STYTCH
}

export const getAuthProvider = (): AuthProviders => getProviderFromToken() ?? AuthProviders.STYTCH

export const WrapperAuthProvider: WrapperComponent = ({ children }) => {
  const SelectedWrapper = wrapperAuthMapper[getAuthProvider()]
  return <SelectedWrapper>{children}</SelectedWrapper>
}
